import React from 'react'
import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'

import { Auth, Logger } from 'aws-amplify';
import { AuthPiece } from 'aws-amplify-react';
import './App.css';
import logo from '../logo.svg';

const logger = new Logger('LoginForm');

class LoginForm extends AuthPiece {
    constructor(props) {
        super(props);

        this.signIn = this.signIn.bind(this);
        Auth.currentAuthenticatedUser()
          .then(user => this.changeState('signUp'))
          .catch(err => console.log('problems with state change'));
    }

    signIn() {
        const { username, password } = this.inputs;
        logger.debug('username: ' + username);
        Auth.signIn(username, password)
            .then(user => this.changeState('signedIn', user))
            .catch(err => this.error(err));
    }


  render() {
      const { authState } = this.props;
      if (!['signIn', 'signedOut', 'signedUp'].includes(authState)) { return null; }

  return (
	<div class="container">
         <div class="row justify-content-center">
			<div class="col-0">
			</div>
			<div class="col-10 col-sm-10 col-md-9 col-lg-8 col-xl-6">
				<img class="cover_logo" src="https://i.ibb.co/gMXwTGG/slice1-3x.png" alt="slice1-3x" border="0"/>
			</div>
			<div class="col-0">
			</div>
		</div>

		<div class="row justify-content-center">
			<div class="col">
			</div>
			<div class="col-10 col-sm-10 col-md-9 col-lg-8 col-xl-6 Intro_z" >
                <p class="brief_content"> Now your next step is to download the App.  Please make a note of your Daily24 name and password and head to one of the following: </p>
			</div>
			<div class="col">
			</div>
	</div>

      <div class="row justify-content-center">

        <div class="col-9 col-sm-8 col-md-12 col-lg-9 col-xl-8">
	    <div class="row justify-content-center">
            <div class="col-8 col-sm-8 col-md-3 col-lg-3 col-xl-3">
                <a href="https://itunes.apple.com/us/app/daily-24/id1366737767?mt=8"><img class="App_store_Link" src="https://i.ibb.co/hCqmJk1/slice38-3x.png" alt="slice38-3x" border="0"/></a>
				<p class="App_store_text">Download for Android (Google Play Store)</p>
            </div>

            <div class="col-8 col-sm-8 col-md-3 col-lg-3 col-xl-3">
                <a href="https://itunes.apple.com/us/app/daily-24/id1366737767?mt=8"><img class="App_store_Link" src="https://i.ibb.co/mFMDNf9/slice39-3x.png" alt="slice39-3x" border="0"/></a>
				<p class="App_store_text">Download for iOS (iPhone)</p>
            </div>
		</div>
		</div>
	</div>
       	    <div class="row justify-content-center">

		    <div class="col-10 col-sm-10 col-md-9 col-lg-8 col-xl-6">

			<p class="brief_content">If you are reading this on a desktop, please search “Daily24” within the app store on your phone or go to the bottom of the email sent to you by the study for a download link to click on your phone.</p>

			</div>

		</div>
	</div>


         );
     }
}
export default LoginForm



// WEBPACK FOOTER //
// ./src/components/LoginForm.js